// components/SEO.tsx
import Head from 'next/head';

type SEOProps = {
  title?: string;
  description?: string;
  canonical?: string;
  ogImage?: string; // /og/cryptocontrol_1200x630.png
};

export function SEO({
  title = 'CryptoControl',
  description = 'CryptoControl é um agregador de notícias de criptomoedas que oferece uma visão abrangente do mercado, permitindo que os usuários acompanhem as últimas notícias, tendências e análises em tempo real.',
  canonical = 'https://cryptocontrol.pro/',
  ogImage = 'https://cryptocontrol.pro/og/cryptocontrol_1200x630.png',
}: SEOProps) {
  return (
    <Head>
      <title>{title}</title>

      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="CryptoControl" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content="CryptoControl" />
      <meta property="og:url" content={canonical} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Head>
  );
}
